import styled, { keyframes } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const _CloseButton = styled(FontAwesomeIcon)`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;

  @media (max-width: 420px) {
    position: fixed;
    top: inherit;
    left: 0;
    margin-top: 10px;
    margin-left: 80%;
  }

  font-size: 20px;

  &:hover {
    cursor: pointer;
    filter: brightness(1.2);
  }
`;

const slideIn = keyframes`
  from { bottom: -100px; }
  to { bottom: 20px; }
`;

const slideOut = keyframes`
  from { bottom: 20px; }
  to { bottom: -100px; }
`;

export const _AnimatedErrorMessage = styled.div`
  z-index: 10;
  display: inline-block;
  visibility: ${(props) => (props.show ? 'visible' : 'hidden')};
  animation: ${(props) => (props.show ? slideIn : slideOut)} 0.5s linear;
  bottom: ${(props) => (props.show ? '20px' : '-100px')};
  transition: visibility 0.5s linear;

  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  font-weight: 600;
  padding: 16px;
  display: flex;
  align-items: flex-start;

  background-color: #a5432f;
  color: white;
  position: fixed;

  span {
    padding: 16px;
    font-size: 18px;
    font-family: aktiv-grotesk, sans-serif;
  }

  button {
    border: 0;
    background: 0;
    color: white;
    cursor: pointer;
  }
`;
